import { Tooltip, Button, Box } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import IdentidadEjemplo from '../../participante/IdentidadEjemplo.jpg'
import { useMediaQuery } from '@mui/material';

import * as React from 'react';

export default function Aval2({ selectedIdentidadAval2, setselectedIdentidadAval2, selectedVoucherIdentidadAval2, setselectedVoucherIdentidadAval2 }) {
    const isMobile = useMediaQuery('(max-width:820px)'); // Detectar si es una pantalla móvil

    const handleFileChangeIdentidadSoli = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'application/pdf') {
            setselectedIdentidadAval2(file);
        } else {
            alert('Por favor seleccione un archivo con formato PDF.');
        }
    };

    const handleDragOverIdentidadSoli = (event) => {
        event.preventDefault();
    };

    const handleClickIdentidadSoli = () => {
        document.getElementById('selectedIdentidadAval2').click();
    };

    const handleDropIdentidadSoli = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type === 'application/pdf') {
            setselectedIdentidadAval2(file);
        } else {
            alert('Por favor suelta un archivo con formato PDF.');
        }
    };

    //-----VOUCHER-----------------
    const handleFileChangeVoucher = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'application/pdf') {
            setselectedVoucherIdentidadAval2(file);
        } else {
            alert('Por favor seleccione un archivo con formato PDF.');
        }
    };

    const handleDragOverVoucher = (event) => {
        event.preventDefault();
    };

    const handleClickVoucher = () => {
        document.getElementById('selectedVoucherIdentidadAval2').click();
    };

    const handleDropVoucher = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type === 'application/pdf') {
            setselectedVoucherIdentidadAval2(file);
        } else {
            alert('Por favor suelta un archivo con formato PDF.');
        }
    };

    return (
        <>
            <Box marginTop={5}>
                {<h3>VI. COPIA DE LA IDENTIDAD EN FORMATO PDF DEL AVAL 2</h3>}
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    onDragOver={handleDragOverIdentidadSoli}
                    onDrop={handleDropIdentidadSoli}
                >
                    <Box
                        style={{
                            padding: '50px',
                            width: isMobile ? '300px' : '700px',
                            textAlign: 'center',
                            borderColor: selectedIdentidadAval2 ? 'green' : 'var(--color-gray-500)',
                            borderRadius: 5,
                            borderWidth: 5,
                            borderStyle: 'dashed',
                        }}
                    >
                        <Tooltip
                            title={
                                <div style={{ textAlign: 'center' }}>
                                    <p style={{ fontSize: 15, textAlign: 'justify' }}>El archivo pdf debe contener la tarjeta de identidad por ambos lados de la siguiente forma:</p>
                                    <img src={IdentidadEjemplo} alt="Identidad Ejemplo" style={{ width: '200px', height: 'auto' }} />
                                </div>
                            }
                            interactive
                        >
                            <CloudUploadIcon style={{ fontSize: 48, color: 'var(--color-gray-500)' }} />
                        </Tooltip>
                        <br />
                        <Button
                            variant="contained"
                            onClick={handleClickIdentidadSoli}
                            style={{ marginTop: '10px', backgroundColor: 'var(--color-surface-muted)' }}
                        >
                            Seleccionar Identidad En PDF
                        </Button>
                        <input
                            id="selectedIdentidadAval2"
                            type="file"
                            accept=".pdf"
                            style={{ display: 'none' }}
                            onChange={handleFileChangeIdentidadSoli}
                        />
                        {!selectedIdentidadAval2 && <p>Seleccione el archivo PDF o Arrástrelo dentro del contenedor</p>}
                        {selectedIdentidadAval2 && <p>Archivo seleccionado: {selectedIdentidadAval2.name}</p>}
                    </Box>
                </Box>
            </Box>

            <Box marginTop={5}>
                {<h3>VII. VOUCHER DE PAGO EN FORMATO PDF DEL AVAL 2</h3>}
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    onDragOver={handleDragOverVoucher}
                    onDrop={handleDropVoucher}
                >
                    <Box
                        style={{
                            padding: '50px',
                            width: isMobile ? '300px' : '700px',
                            textAlign: 'center',
                            borderColor: selectedVoucherIdentidadAval2 ? 'green' : 'var(--color-gray-500)',
                            borderRadius: 5,
                            borderWidth: 5,
                            borderStyle: 'dashed',
                        }}
                    >

                        <CloudUploadIcon style={{ fontSize: 48, color: 'var(--color-gray-500)' }} />
                        <br />
                        <Button
                            variant="contained"
                            onClick={handleClickVoucher}
                            style={{ marginTop: '10px', backgroundColor: 'var(--color-surface-muted)' }}
                        >
                            Seleccionar Voucher En PDF
                        </Button>
                        <input
                            id="selectedVoucherIdentidadAval2"
                            type="file"
                            accept=".pdf"
                            style={{ display: 'none' }}
                            onChange={handleFileChangeVoucher}
                        />
                        {!selectedVoucherIdentidadAval2 && <p>Seleccione el archivo PDF o Arrástrelo dentro del contenedor</p>}
                        {selectedVoucherIdentidadAval2 && <p>Archivo seleccionado: {selectedVoucherIdentidadAval2.name}</p>}
                    </Box>
                </Box>
            </Box>
        </>
    );
}


